export const STATIONUPLOADFILE_LIST_REQUEST = 'STATIONUPLOADFILE_LIST_REQUEST';
export const STATIONUPLOADFILE_LIST_SUCCESS = 'STATIONUPLOADFILE_LIST_SUCCESS';
export const STATIONUPLOADFILE_LIST_FAILURE = 'STATIONUPLOADFILE_LIST_FAILURE';
export const STATIONUPLOADFILE_ADD_REQUEST = 'STATIONUPLOADFILE_ADD_REQUEST';
export const STATIONUPLOADFILE_ADD_SUCCESS = 'STATIONUPLOADFILE_ADD_SUCCESS';
export const STATIONUPLOADFILE_ADD_FAILURE = 'STATIONUPLOADFILE_ADD_FAILURE';
export const STATIONUPLOADFILE_DELETE_REQUEST = 'STATIONUPLOADFILE_DELETE_REQUEST';
export const STATIONUPLOADFILE_DELETE_SUCCESS = 'STATIONUPLOADFILE_DELETE_SUCCESS';
export const STATIONUPLOADFILE_DELETE_FAILURE = 'STATIONUPLOADFILE_DELETE_FAILURE';

export const stationUploadFileListRequest = (station) => {
    return {
        type: STATIONUPLOADFILE_LIST_REQUEST,
        station: station,
    }
}

export const stationUploadFileListSuccess = (result) => {
    return {
        type: STATIONUPLOADFILE_LIST_SUCCESS,
        result,
    }
}

export const stationUploadFileListFailure = (error) => {
    return {
        type: STATIONUPLOADFILE_LIST_FAILURE,
        error,
    }
}

export const stationUploadFileAddRequest = (data) => {
    return {
        type: STATIONUPLOADFILE_ADD_REQUEST,
        data: data
    }
}

export const stationUploadFileAddSuccess = (result) => {
    return {
        type: STATIONUPLOADFILE_ADD_SUCCESS,
        result
    }
}

export const stationUploadFileAddFailure = (error) => {
    return {
        type: STATIONUPLOADFILE_ADD_FAILURE,
        error,
    }
}

export const stationUploadFileDeleteRequest = (station, id) => {
    return {
        type: STATIONUPLOADFILE_DELETE_REQUEST,
        station: station,
        id: id,
    }
}

export const stationUploadFileDeleteSuccess = (result) => {
    return {
        type: STATIONUPLOADFILE_DELETE_SUCCESS,
        result
    }
}

export const stationUploadFileDeleteFailure = (error) => {
    return {
        type: STATIONUPLOADFILE_DELETE_FAILURE,
        error,
    }
}